import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { notifyError, notifyTopRight } from "../../components/Common/Toaster";
import { followUp } from "../../../services/UserServices/UserService";

const ReportMessages = ({ item, show, text, data, onHide, getTableData, id }) => {
  const [loader, setLoader] = useState(false);
  const reportReason = [
    {
      name: "Inappropriate Messages or Content",
      id: "1",
    },
    { name: "Fake or Misleading Profile", id: "2" },
    { name: "Harassment or Bullying", id: "3" },
    { name: "Unwanted Solicitation or Spam", id: "4" },
    { name: "Scamming or Fraudulent Activity", id: "5" },
    { name: "Profile Picture Violation", id: "6" },
    { name: "Underage User", id: "7" },
    { name: "Offensive Behavior", id: "8" },
    {
      name: "Child Safety Concern (Exploitation, Endangerment, or Abuse)",
      id: "9",
    },
    { name: "Other", id: "10" },
  ];

  const matchingNames = reportReason
    .filter((reason) => data.includes(reason.id))
    .map((reason) => reason.name);

  const followUpSend = async () => {
    if (item._id === "") {
      notifyError("Please select a report.");
      return;
    }

    setLoader(true);
    try {
      const response = await followUp({
        subReportIds: [item._id],
        reportId: id,
      });
      notifyTopRight(response.data?.message);
      getTableData();
      onHide();
    } catch (error) {
      notifyError(error?.response?.data?.message);
    }
    setLoader(false);
  };

  const renderReasons = (reasons) => (
    <ul className="mb-0 ps-3">
      {reasons.map((reason, index) =>
        reason !== "Other" ? (
          <li key={`${reason}-${index}`}>
            <span className="fw-bold text-black">{index + 1}. </span>
            {reason}
          </li>
        ) : null
      )}
      {text ? (
        <li>
          <span className="fw-bold text-black">Other: </span>
          {text}
        </li>
      ) : null}
    </ul>
  );

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="report-messages-modal"
    >
      <div className="modal-body">
        {matchingNames.length === 0
          ? renderReasons(data)
          : renderReasons(matchingNames)}
      </div>
      <div className="modal-footer report-messages-modal__footer">
        <button
          type="button"
          onClick={followUpSend}
          className="btn btn-primary"
          disabled={loader || item?.isFollowUpMessageSent}
        >
          <i className="flaticon-checkmark"></i>{" "}
          {item?.isFollowUpMessageSent
            ? "Follow-Up Sent"
            : loader
              ? "Sending..."
              : "Follow-Up Pending"}
        </button>
        <button type="button" onClick={onHide} className="btn btn-danger">
          <i className="flaticon-delete-1"></i> Cancel
        </button>
      </div>
    </Modal>
  );
};

export default ReportMessages;
